import { DriverInfo, DriverType } from './DriverInfo';
// The odsp driver package has some dependencies on packages that are not tree-shaking friendly, we need to import this directly since this module gets bundled with host code
import { checkUrl } from '@fluidframework/odsp-driver/lib/checkUrl';
import { getLocatorFromOdspUrl } from '@fluidframework/odsp-driver/lib/odspFluidFileLink';

/**
 * Tries to resolve necessary driver information needed for loading a Fluid component.
 * @param documentUrl The URL or other supported string from a known Office Fluid document source.
 * @returns undefined if the URL is not supported, otherwise extracted driver information from the URL needed for load.
 */
export function tryResolveDriverInfo(documentUrl: string): DriverInfo | undefined {
  let url: URL | undefined;
  try {
    url = new URL(documentUrl);
  } catch {
    // Ignore failure to parse inputUrl as fully qualified URL as it may be partial (only path and query params)
    return undefined;
  }

  return generateOdspDriverInfoFromUrl(url);
}

function generateOdspDriverInfoFromUrl(documentUrl: URL): DriverInfo | undefined {
  const precheckInfo = checkUrl(documentUrl);
  const locator = getLocatorFromOdspUrl(documentUrl);

  let siteOrigin: string | undefined;
  try {
    if (locator?.siteUrl) {
      siteOrigin = new URL(locator?.siteUrl).origin;
    }
  } catch {}

  if (!precheckInfo) {
    return undefined;
  }

  return {
    type: DriverType.SPO,
    documentUrl: documentUrl.href,
    componentId: precheckInfo.containerPath,
    containerCodeHint: locator?.containerPackageName,
    // We want to preconnect to the snapshot endpoint, which has the same domain as the site URL
    preconnectDomains: siteOrigin ? [siteOrigin] : undefined
  };
}
